import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { processGoogleSession, setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error('Session invalide');
        navigate('/auth', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      const result = await processGoogleSession(sessionId);

      if (result.success) {
        toast.success('Connexion réussie !');
        // Clear the hash and navigate to feed with user data
        window.history.replaceState(null, '', '/feed');
        navigate('/feed', { replace: true, state: { user: result.user } });
      } else {
        toast.error(result.error);
        navigate('/auth', { replace: true });
      }
    };

    processSession();
  }, [processGoogleSession, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" style={{ width: 40, height: 40 }} />
        <p className="text-muted-foreground">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
